<template>
  <div id="detail" class="card m-2 shadow-sm">
    <div v-if="!order.id" class="no-order">
      <h2>No Order Selected</h2>
    </div>
    <div v-if="order.id">
      <div class="navbar nav px-2 border-bottom">
        <action-buttons :order="order"></action-buttons>
      </div>
      

      <order-meta :order="order"></order-meta>
      <div class="">
        <ul class="nav nav-tabs">
          <li class="nav-item m-r" style="width: 15px;"></li>
          <li class="nav-item">
            <a class="nav-link active" href="#" data-toggle="tab" data-target="#items">
                Items
              </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="tab" data-target="#docs">
              Documents
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="tab" data-target="#billable">
              Billable Activity
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="tab" data-target="#history">
              History
            </a>
          </li>
        </ul>
      </div>

      <div class="tab-content bg-white">
        <div class="tab-pane active" id="items">
          <items-tab :order="order"></items-tab>
        </div>
        <div class="tab-pane" id="docs">
          <docs-tab :order="order"></docs-tab>
        </div>
        <div class="tab-pane" id="billable">
          <billable-tab :order="order"></billable-tab>
        </div>
        <div class="tab-pane" id="history">
          <history-tab :order="order"></history-tab>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import OrderMeta from '@/components/inbound/OrderMeta'
  import ItemsTab from '@/components/inbound/ItemsTab'
  import DocsTab from '@/components/inbound/DocsTab'
  import BillableTab from '@/components/inbound/BillableTab'
  import HistoryTab from '@/components/inbound/HistoryTab'
  import ActionButtons from '@/components/inbound/ActionButtons'

  export default {
    name: 'order-detail',

    components: {
      OrderMeta,
      ItemsTab,
      DocsTab,
      BillableTab,
      ActionButtons,
      HistoryTab
    },

    props: ['order'],

    methods: {

    }
  }
</script>
<style scoped>
.no-order {
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: space-around;
  height: calc(100vh - 48px);
  flex-direction: column;
}

.no-order h2 {
  justify-self: center;
  color: #cfcfcf;
}
</style>